// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2ecgJ","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1Dfyh"};